export const FORMAT_YYYY_MM_DD_HHmm = "YYYY-MM-DD HH:mm"
export const INIT_STR = "";
export const INIT_NUMBER = 0;
export const BLANK = ""
export const RESULT_KBN = {
    SUCCESS: 0,
    INFO: 1,
    ERROR: -9,
}
export const MSG = {
    SUCCESS_UPD_STATUS: "ステータス更新に成功しました。",
    ERR_GET_ACCOUNT: "アカウント情報取得に失敗しました。",
    ERR_UPD_STATUS: "ステータス更新に失敗しました。",
}
